export default __webpack_public_path__ + "static/media/crop.09ab8a34.svg";